import { render, staticRenderFns } from "./IconWheelDesign.vue?vue&type=template&id=ed0b8730"
import script from "./IconWheelDesign.vue?vue&type=script&lang=js"
export * from "./IconWheelDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports